import './iphoneaircarousel.css';
import iPhoneAirImage from '../../../assets/apple/iPhone17/iPhone17Slides/iPhoneAir.png';

import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { useNavigate } from 'react-router-dom';

const IPhoneAirCarousel = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const pauseAutoplay = () => {
    swiperInstance?.autoplay?.stop();
  };

  const resumeAutoplay = () => {
    swiperInstance?.autoplay?.start();
  };

  const handleViewDetails = (productId) => {
    navigate(
      `/applestore/iphone-products-list/iphone-detail-page/iphone/${productId}`
    );
  };

  return (
    <Swiper
      modules={[Pagination, Navigation, Autoplay]}
      navigation
      pagination={{ type: 'progressbar', clickable: true }}
      slidesPerView={1}
      spaceBetween={30}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      style={{ padding: '0 3% 3% 3%;', borderRadius: '40px' }}
      onSwiper={(swiper) => setSwiperInstance(swiper)}
    >
      {/* iPhone Air Slide */}
      <SwiperSlide>
        <section className="iphoneair-carousel">
          <div className="iphoneair-content">
            <h1 className="iphoneair-title">iPhone Air</h1>
            <h2 className="iphoneair-subtitle">Starts at Rs. 1,01,900</h2>
            <p className="iphoneair-emi">or No Cost EMI at Rs. 4,246 p.m.</p>

            <div className="iphoneair-image-wrapper">
              <img
                src={iPhoneAirImage}
                alt="iPhone Air"
                className="iphoneair-image"
              />
            </div>

            <div className="iphoneair-offers">
              <p>
                Cashback up to <strong>Rs. 4000</strong> on Axis/ICICI Credit Cards.
              </p>
              <p className="plus-sign">+</p>
              <p>
                Exchange Bonus up to <strong>Rs. 6000</strong>
              </p>
            </div>

            <button
              className="iphoneair-view-details-btn"
              onClick={() => handleViewDetails(4)}
              onMouseEnter={pauseAutoplay}
              onMouseLeave={resumeAutoplay}
            >
              View Details
            </button>

            <p className="iphoneair-terms">
              *Terms and Conditions Apply. <br />
              The EMI amount may differ from person to person. <br />
              EMI offers are subject to changes without prior notice.
            </p>
          </div>
        </section>
      </SwiperSlide>
    </Swiper>
  );
};

export default IPhoneAirCarousel;
